module.exports = __webpack_public_path__ + "img/stack_7.ff91d805.png";